const TRAFFIC_SOURCE_KEY = 'trafficSource';

const KNOWN_SOURCES = ['xovi.de', 'xovi.com'];

export const captureTrafficSource = () => {
  try {
    if (sessionStorage.getItem(TRAFFIC_SOURCE_KEY)) {
      return;
    }

    let source = 'direct';
    const referrer = document.referrer;

    if (referrer) {
      const hostname = new URL(referrer).hostname.replace(/^www\./, '');
      const matched = KNOWN_SOURCES.find(
        known => hostname === known || hostname.endsWith(`.${known}`)
      );
      if (matched) {
        source = matched;
      }
    }

    sessionStorage.setItem(TRAFFIC_SOURCE_KEY, source);
  } catch (error) {
    console.error('Failed to capture traffic source', error);
  }
};

export const getTrafficSource = (): string | null => {
  try {
    return sessionStorage.getItem(TRAFFIC_SOURCE_KEY);
  } catch (error) {
    console.error('Failed to read traffic source', error);
    return null;
  }
};
